import { QuickReplyInterface } from "@/interfaces/quickReply.interface";
import axios from "@/libs/axios";
import { RequestQueryBuilder } from "@rewiko/crud-request";
import { defineStore } from "pinia";

interface State {
    quickReplies: QuickReplyInterface[];
    isLoadingQuickReplies: boolean;
}

export const useQuickRepliesStore = defineStore("quick-replies", {
    state: (): State => ({
        quickReplies: [],
        isLoadingQuickReplies: false,
    }),
    actions: {
        async fetchQuickReplies(requestQueryBuilder?: RequestQueryBuilder): Promise<void> {
            this.isLoadingQuickReplies = true;

            const { data } = await axios.get<QuickReplyInterface[]>(`${process.env.VUE_APP_PUBLIC_API}/quick-replies`, {
                params: requestQueryBuilder?.queryObject,
            });

            this.quickReplies = data;
            this.isLoadingQuickReplies = false;

            // @COMMENTED because this method is called within other methods that is not directly within the setup()-scope.
            //useQuery<Pick<AxiosResponse<QuickReplyInterface[]>, "data">>(
            //    ["quick-replies", requestQueryBuilder?.queryObject],
            //    () => {
            //        this.isLoadingQuickReplies = true;
            //        return axios.get<QuickReplyInterface[]>(`${process.env.VUE_APP_PUBLIC_API}/quick-replies`, {
            //            params: requestQueryBuilder?.queryObject,
            //        });
            //    },
            //    {
            //        staleTime: 3000, // 3s, because no mutations yet.
            //        placeholderData: { data: [] },
            //        onSuccess: (response) => (this.quickReplies = response.data),
            //        onSettled: () => (this.isLoadingQuickReplies = false),
            //    }
            //);
        },
    },
});
